/**
 * Curriculum Progress API service.
 * BE endpoint: GET /app/learning/curriculum-progress
 */

import { TGetCurriculumProgressResDto } from "@/api/services/main/curriculum-progress/dtos/get-curriculum-progress.dto";
import { clientApi } from "@/utils/api";
import { TApiRes } from "@/types/api";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useMemo } from "react";

export const fetchCurriculumProgressApi = async (): Promise<TGetCurriculumProgressResDto> => {
  const res = await clientApi.get<TApiRes<TGetCurriculumProgressResDto>>("/learning/curriculum-progress");
  return res.data.data;
};

export const useCurriculumProgress = () => {
  const query = useQuery<TGetCurriculumProgressResDto>({
    queryKey: [QUERY_KEYS.STUDY.CURRICULUM_PROGRESS],
    queryFn: () => fetchCurriculumProgressApi(),
  });

  const progress = useMemo(() => {
    if (query.data) {
      return {
        ...query.data,
        subjects: [...query.data.subjects].sort((a, b) => a.displayOrder - b.displayOrder),
      };
    }
    return { totalSubjects: 0, completedSubjects: 0, inProgressSubjects: 0, subjects: [] };
  }, [query.data]);

  return {
    progress,
    isLoading: query.isLoading,
  };
};
